export type Offre = {
  id: string
  /** Intitulé du poste tel qu'il sera lu par les candidats et par Google */
  poste: string
  /**
   * Ville ou secteur. Laisser vide lorsque la localisation exacte
   * ne doit pas être communiquée publiquement.
   */
  ville?: string
  /** Secteur d'activité de l'entreprise partenaire (sans la nommer) */
  secteur: string
  /** Formations compatibles avec l'offre */
  formations: { label: string; id: string }[]
  /** Missions principales confiées à l'alternant */
  missions: string[]
  /** Condition particulière éventuelle (ex. permis B) */
  condition?: string
  /** Une offre fermée n'apparaît plus sur le site */
  ouverte: boolean
}

const TP_CV = {
  label: 'TP Conseiller de Vente',
  id: 'tp-conseiller-vente',
}
const BTS_NDRC = {
  label: 'BTS NDRC',
  id: 'bts-ndrc',
}
const TP_NTC = {
  label: 'TP Négociateur Technico-Commercial',
  id: 'tp-ntc',
}

/**
 * Offres d'alternance de nos entreprises partenaires.
 * Les noms des entreprises ne sont pas publiés : elles sont présentées
 * comme entreprises partenaires de Zillenium Alternance.
 * Pour retirer une offre pourvue, passer "ouverte" à false.
 */
export const OFFRES: Offre[] = [
  {
    id: 'conseiller-vente-reseaux-sociaux-sens',
    poste: 'Conseiller(ère) de vente et réseaux sociaux en prêt-à-porter',
    ville: 'Sens (89)',
    secteur: 'Boutique de prêt-à-porter',
    formations: [TP_CV, BTS_NDRC],
    missions: [
      'Accueil client et conseil en boutique',
      'Vente et encaissement',
      'Merchandising et mise en valeur des produits',
      "Création de contenus et animation des réseaux sociaux de l'enseigne",
    ],
    ouverte: true,
  },
  {
    id: 'conseiller-vente-pret-a-porter-sens',
    poste: 'Conseiller(ère) de vente en prêt-à-porter',
    ville: 'Sens (89)',
    secteur: 'Magasin de prêt-à-porter',
    formations: [TP_CV],
    missions: [
      'Accueil et conseil client',
      'Vente et encaissement',
      'Rangement et réassort',
      'Mise en valeur des produits',
    ],
    ouverte: true,
  },
  {
    id: 'employe-commercial-supermarche',
    poste: 'Employé(e) commercial(e) polyvalent(e) en supermarché',
    secteur: 'Supermarché — rayons secs ou rayons frais',
    formations: [TP_CV],
    missions: [
      'Mise en rayon et réassort',
      'Contrôle des produits et étiquetage',
      'Rangement et entretien de l’espace de vente',
      'Conseil client',
    ],
    ouverte: true,
  },
  {
    id: 'employe-commercial-hypermarche-frais',
    poste: 'Employé(e) commercial(e) en hypermarché — secteur frais',
    secteur: 'Hypermarché — fruits et légumes, boucherie, espaces de vente',
    formations: [TP_CV],
    missions: [
      'Mise en rayon et présentation des produits',
      'Accueil et conseil client',
      'Contrôle des marchandises',
      'Entretien du rayon',
    ],
    ouverte: true,
  },
  {
    id: 'vendeur-polyvalent-epicerie-joigny',
    poste: 'Vendeur(se) polyvalent(e) en épicerie',
    ville: 'Joigny (89)',
    secteur: 'Épicerie de proximité',
    formations: [TP_CV],
    missions: [
      'Accueil et conseil client',
      'Encaissement',
      'Mise en rayon et réception des marchandises',
      'Entretien du point de vente',
    ],
    ouverte: true,
  },
  {
    id: 'commercial-automobile',
    poste: 'Commercial(e) automobile en alternance',
    secteur: 'Garage automobile',
    formations: [TP_NTC],
    missions: [
      'Accueil des clients et découverte des besoins',
      'Présentation des véhicules',
      'Suivi des prospects et relances commerciales',
      'Participation à la vente',
    ],
    ouverte: true,
  },
  {
    id: 'vendeur-conseil-aire-autoroute',
    poste: "Vendeur(se)-conseil sur une aire d'autoroute",
    secteur: "Enseigne située sur une aire d'autoroute",
    formations: [TP_CV],
    missions: [
      'Accueil et conseil client',
      'Encaissement',
      'Mise en rayon et gestion des produits',
      "Entretien de l'espace de vente",
    ],
    condition: 'Permis B obligatoire',
    ouverte: true,
  },
]
